import React, { useState, useEffect } from "react";

import AWS from "aws-sdk";
import { colors } from "../../../../../../../themes/Colors";
import { BaseButtons } from "../../../../../../common-components";

const BuzzCard = ({
  senderTitle,
  buzzTitle,
  quickDescription,
  longDescription,
  selectedItem,
  index,
  postType,
  sourceLink,
  tagsData,
  postId,
  subPostType,
  option2,
  setLoading,
  setMessage,
  setPopUpTitle,
  setToastPop,
  setRefresh,
  refresh,
  type,
}) => {
  const [detailsOpen, setDetailsOpen] = useState(false);
  const [imageLink, setImageLink] = useState("");

  const getUplaodImage = async () => {
    const S3_BUCKET = process.env.REACT_APP_BUCKET;
    const apiKey = process.env.REACT_APP_AWS_ACCESS_KEY_ID;
    const secrectapiKey = process.env.REACT_APP_AWS_SECRET_KEY_ID;
    AWS.config.update({
      accessKeyId: apiKey,
      secretAccessKey: secrectapiKey,
    });
    const s3 = new AWS.S3({
      params: { Bucket: S3_BUCKET },
      region: process.env.REACT_APP_REGION,
      signatureVersion: "v4",
    });

    const params = {
      Bucket: S3_BUCKET,
      Key: postId,
    };

    var promise = s3.getSignedUrlPromise("getObject", params);
    // return promise;
    promise.then(
      function (url) {
        if (url) {
          setImageLink(url);
        }
        return url;
      },
      function (err) {
        console.log(err);
      }
    );
  };

  const IconDisplay = () => {
    if (postType === "BOLO") {
      return require("./buzzIcons/boloIcon1.png");
    } else if (postType === "VEHICLE") {
      return require("./buzzIcons/vehicleIcon1.png");
    } else if (postType === "WEATHER") {
      return require("./buzzIcons/weatherIcon1.png");
    } else if (postType === "TRAFFIC") {
      return require("./buzzIcons/trafficIcon1.png");
    } else {
      return require("./buzzIcons/generalIcon1.png");
    }
  };

  const ColorChange = () => {
    if (postType === "BOLO") {
      return "#9BD0E1";
    } else if (postType === "VEHICLE") {
      return "#EBCCFF";
    } else if (postType === "WEATHER") {
      return "#D26466";
    } else if (postType === "TRAFFIC") {
      return "#FBBB62";
    } else {
      return "#8ED399";
    }
  };

  const AnswerRequest = async (answer) => {
    setLoading(true);

    try {
      const response = await fetch(
        process.env.REACT_APP_BACKEND_URL + "/buzzPost/approveOrDeclinePosts",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            // Authorization: `bearer ${token}`,
          },
          body: JSON.stringify({
            postId: postId,
            answer: answer,
          }),
        }
      );

      const respnseData = await response.json();

      if (respnseData.success) {
        setDetailsOpen(false);
        setToastPop(true);
        setMessage(respnseData.success);
        setPopUpTitle("SUCCESS");
        setLoading(false);
        setRefresh(refresh ? false : true);
        // setVehicleSearchArray(respnseData.enatisVehicles);
      } else {
        setToastPop(true);
        setMessage(respnseData.error);
        setPopUpTitle("FAILURE");
        setLoading(false);
      }
    } catch (err) {
      setLoading(false);
      console.log("error", err);
    }
  };

  useEffect(() => {
    getUplaodImage();
  }, []);
  return (
    <div
      style={{
        width: "100%",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        flexDirection: "column",
        marginTop: 100,
      }}
    >
      <div
        // onClick={detailsOpen ? null : () => setDetailsOpen(true)}
        style={{
          backgroundColor: colors.white,
          borderRadius: 8,
          width: 400,
          borderStyle: "solid",
          borderColor: "#00000020",
          borderWidth: 1,

          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          position: "relative",
          transition: "all 0.3s",
          // WebkitBoxShadow: "-5px 5px 15px -1px #00000070",
        }}
      >
        <div
          style={{
            display: "flex",
            width: "94%",
            justifyContent: "flex-start",
            alignItems: "center",
            marginTop: 10,
          }}
        >
          <img
            alt="icon"
            src={IconDisplay()}
            style={{
              height: 50,
              padding: 10,
              backgroundColor: colors.white,
              position: "absolute",
              borderRadius: option2 ? 10 : 40,
              left: option2 ? -20 : -15,
              top: 15,
              WebkitBoxShadow: "-5px 5px 10px -1px #00000030",
            }}
          />

          <div
            style={{
              height: "100%",
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "flex-start",
              marginLeft: option2
                ? detailsOpen
                  ? 10
                  : 50
                : detailsOpen
                ? 10
                : 45,
              width: "100%",
            }}
          >
            <div
              style={{
                fontWeight: "bold",
                fontSize: 14,
                display: "flex",
                width: "100%",
                flex: 0.7,
                minHeight: detailsOpen ? 0 : 50,
                maxHeight: detailsOpen ? 20 : 50,
                overflow: "hidden",
              }}
            >
              {postType
                ? buzzTitle
                : postType.toLocaleUpperCase() + " - " + subPostType
                ? subPostType.toLocaleUpperCase()
                : null}
            </div>
            {/* <div style={{ height: 10 }}></div> */}
            <div
              style={{
                fontSize: 12,
                display: "flex",
                width: "100%",
                flex: 0.3,
              }}
            >
              {senderTitle} <div style={{ flex: 1 }} />
              <div style={{ width: 100, textAlign: "right" }}>
                {/* {postType.toLocaleUpperCase()} */}
              </div>
            </div>
          </div>
        </div>
        <div
          style={{
            width: "90%",
            fontSize: 12,
            marginTop: detailsOpen ? 5 : 12,
            display: "flex",
            marginBottom: 5,
            marginLeft: detailsOpen ? -10 : 20,
            overflowX: detailsOpen ? null : "hidden",
            minHeight: 23,
            borderRadius: 8,
          }}
        >
          {tagsData
            ? tagsData.map((tag, index) => {
                return (
                  <div
                    style={{
                      marginLeft: 4,
                      fontWeight: "bold",
                      paddingLeft: 5,
                      paddingRight: 5,
                      paddingTop: 5,
                      paddingBottom: 5,
                      borderRadius: 20,
                      backgroundColor: colors.white,
                      fontSize: detailsOpen ? 9 : 11,
                      WebkitBoxShadow: detailsOpen
                        ? "-1px 1px -1px 1px #00000070"
                        : null,
                    }}
                    key={index}
                  >
                    #{tag.toLocaleUpperCase()}
                  </div>
                );
              })
            : null}
        </div>
        <div
          style={{
            flex: detailsOpen ? 1 : 0,
            display: "flex",
            width: "94%",
            overflow: "hidden",

            justifyContent: "center",
            alignItems: "center",
            position: "relative",
            flexDirection: "column",
          }}
        >
          <div
            style={{
              height: "100%",
              width: "100%",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              borderRadius: 8,
              // opacity: 0.5,
              flexDirection: "column",
              overflow: "hidden",
            }}
          >
            <img
              alt="icon"
              src={imageLink}
              style={{ height: "100%", minHeight: 150, maxHeight: 250 }}
            />
          </div>
          <div
            style={{
              // position: "absolute",
              // bottom: 10,
              width: "90%",
              fontSize: 12,
              // left: 10,
              borderRadius: 8,
              backgroundColor: "#FFFFFF50",
              marginTop: 10,
              marginBottom: 10,
            }}
          >
            {longDescription}
          </div>
        </div>
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            width: "100%",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <a
            href={sourceLink}
            target="_blank"
            style={{
              width: 120,
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              textDecoration: "none",
            }}
          >
            <BaseButtons
              label={"SOURCE LINK"}
              backgroundColor={colors.greenDark}
              borderRadius={8}
              width={"100%"}
            />
          </a>
          <div style={{ marginLeft: 10 }}>
            <BaseButtons
              label={"COMMENTS"}
              backgroundColor={colors.greenDark}
              borderRadius={8}
              width={210}
            />
          </div>
        </div>
        {type === "requests" ? (
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              width: "100%",
              justifyContent: "center",
              alignItems: "center",
              marginTop: 10,
            }}
          >
            <BaseButtons
              label={"APPROVE"}
              backgroundColor={colors.greenLight}
              borderRadius={8}
              width={"45%"}
              onClick={() => AnswerRequest("APPROVED")}
            />

            <div style={{ width: 10 }} />

            <BaseButtons
              label={"DECLINE"}
              backgroundColor={colors.orangeDark}
              borderRadius={8}
              width={"45%"}
              onClick={() => AnswerRequest("DECLINED")}
            />
          </div>
        ) : null}

        <div style={{ height: 10 }} />
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            width: "100%",
            justifyContent: "center",
            alignItems: "center",
          }}
        ></div>

        <div style={{ height: 10 }} />
      </div>
    </div>
  );
};

export default BuzzCard;
